module.exports = __webpack_public_path__ + "e53a151815d8f512453ee1d7cbca35c0.svg";